
export default {
  props: {
    items: {
      type: Array,
      required: true,
      validator(value) {
        return value.every((item) => !!item.name && !!item.value)
      },
    },
  },
}
